import Swal from "sweetalert2";
import { exhibitionActions } from "reducers/exhibition";

export const exhibitionAlertSuccess = (textType, createExh, history, dispatch, type) => {
    Swal.fire({
        text: `${textType}이 완료되었습니다.`,
        icon: 'success',
        confirmButtonText: '확인',
    }).then((result) => {
        if (result.isConfirmed) {
            history.goBack();
            if (type === 'eng') {
                dispatch(exhibitionActions.setType('eng'));
                dispatch(exhibitionActions.setPanelValue(1));
            } else {
                dispatch(exhibitionActions.setType('kor'));
                dispatch(exhibitionActions.setPanelValue(0));
            }
            dispatch(exhibitionActions.setExhibitionRoom({
                id: null,
                seq: null,
                imageAltText: "",
                name: "",
                introduction: "",
                roomNo: "",
                invalid: false,
                language: { id: 1 },
                parentId: null,
                imageUrl: "",
                commentator: { id : null },
                commentatorForKid: { id : null },
                commentatorForBlind: { id : null },
            }))
            dispatch(exhibitionActions.setSubTopicList([]));
            dispatch(exhibitionActions.setFile(null));
            dispatch(exhibitionActions.setPreviewImage(null));
        }
    })
}